import { IIsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";

export interface IIsiDtoPlPerformanceAnalyserResponse extends IIsiDtoPresentationLogicResponse  {
}
export class IsiDtoPlPerformanceAnalyserResponse extends IsiDtoPresentationLogicResponse implements IIsiDtoPlPerformanceAnalyserResponse {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.Objet.PerformanceAnalyser.IsiDtoPlPerformanceAnalyserResponse, Isilog.IsiComponent.IsiDataTransferObject";

    constructor(data?: IIsiDtoPlPerformanceAnalyserResponse) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
        }
    }

    static fromJS(data?: IIsiDtoPlPerformanceAnalyserResponse): IsiDtoPlPerformanceAnalyserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlPerformanceAnalyserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        return data;
    }
}
export interface IIsiDtoPlPerformanceAnalyserRequest extends IIsiDtoPresentationLogicRequest  {
    pageOnLoadEndStartTime?: string;
    pageEndStartTime?: string;
    screenId?: string;
    response?: IIsiDtoPlPerformanceAnalyserResponse;
}
export class IsiDtoPlPerformanceAnalyserRequest extends IsiDtoPresentationLogicRequest implements IIsiDtoPlPerformanceAnalyserRequest {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.Objet.PerformanceAnalyser.IsiDtoPlPerformanceAnalyserRequest, Isilog.IsiComponent.IsiDataTransferObject";
    pageOnLoadEndStartTime?: string;
    pageEndStartTime?: string;
    screenId?: string;
    response?: IsiDtoPlPerformanceAnalyserResponse;

    constructor(data?: IIsiDtoPlPerformanceAnalyserRequest) {
        super(data);
        if (data) {
            this.response = data.response && !(<any>data.response).toJSON ? new IsiDtoPlPerformanceAnalyserResponse(data.response) : <IsiDtoPlPerformanceAnalyserResponse>this.response;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pageOnLoadEndStartTime = _data["pageOnLoadEndStartTime"] !== undefined ? _data["pageOnLoadEndStartTime"] : <any>null;
            this.pageEndStartTime = _data["pageEndStartTime"] !== undefined ? _data["pageEndStartTime"] : <any>null;
            this.screenId = _data["screenId"] !== undefined ? _data["screenId"] : <any>null;
            this.response = _data["response"] ? IsiDtoPlPerformanceAnalyserResponse.fromJS(_data["response"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlPerformanceAnalyserRequest): IsiDtoPlPerformanceAnalyserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlPerformanceAnalyserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["pageOnLoadEndStartTime"] = this.pageOnLoadEndStartTime !== undefined ? this.pageOnLoadEndStartTime : <any>null;
        data["pageEndStartTime"] = this.pageEndStartTime !== undefined ? this.pageEndStartTime : <any>null;
        data["screenId"] = this.screenId !== undefined ? this.screenId : <any>null;
        data["response"] = this.response != null ? (<any>this.response).toJSON() : <any>null;
        return data;
    }
}
